module.exports = require("./moment.js");


//////////////////
// WEBPACK FOOTER
// moment (bower component)
// module id = 615
// module chunks = 1